<div class="tw-py-4">
  <hub-additional-information
    [processId]="processId"
    [processName]="processName"
    [processCreatedDate]="processCreatedDate" />
  <div class="tw-w-20 tw-m-auto">
    <p-timeline [value]="steps" align="alternate">
      <ng-template pTemplate="marker" let-step>
        <span>
          @switch (step.status) {
            @case ('Iniciado') {
              <i class="pi pi-circle tw-text-blue-500"></i>
            }
            @case ('Em processamento') {
              <i class="pi pi-hourglass tw-text-yellow-500"></i>
            }
            @default {
              <i class="pi pi-check-circle tw-text-green-500"></i>
            }
          }
        </span>
      </ng-template>

      <ng-template pTemplate="content" let-step>
        <hub-timeline-card
          [createdDate]="step.createdAt"
          [processStepId]="step.id"
          [status]="step.statusDescription"
          [step]="step.workflowStepName" />
      </ng-template>
    </p-timeline>
  </div>
</div>
